/* eslint-disable @nx/enforce-module-boundaries */
import {
  FormControl,
} from '@mybridge/ui';
import React, { useState, useEffect } from 'react';
import { Input} from '@mybridge/ui/input';
import {VStack } from '@mybridge/ui/layout';
import { TagsInput } from '../tags-input';
import { Box } from '@chakra-ui/react';
import { EmailDropdown } from '../email-dropdown';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const EmailsTagsInput = ({
  value,
  onChange,
  placeholder = 'Add Email',
  keyName = 'email',
  round = true,
  ...props
}) => {
  const { t } = useTranslator();
  const [emailList, setEmailList] = useState(Array.isArray(value) ? value : []); // Ensure emailList is an array
  useEffect(() => {
    if (Array.isArray(value)) {
      setEmailList(value);
    }
  }, [value]);
  // Email validation
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  // Handle adding a valid email
  const handleAddEmail = (emailToAdd) => {
    if (validateEmail(emailToAdd) && !emailList.includes(emailToAdd)) {
      const newEmailList = [...emailList, emailToAdd];
      setEmailList(newEmailList);
      onChange(newEmailList)
    }
  };
const handleAddEmails=(ee)=>{
  setEmailList(ee)
  onChange(ee)
}
  return (
    <VStack alignItems="flex-start" w="100%">
      <Box>
        <FormControl>
          {/* <FormLabel>Email</FormLabel> */}
          <TagsInput
            title="Email"
            value={emailList}
            onChange={(e) => handleAddEmails(e)}
          >
            {({ addTag, setEdit }) => (
              <EmailDropdown
                allowCreate
                onChange={(obj) => {
                  handleAddEmail(obj?.name)
                  addTag?.(obj?.name);
                  setEdit(false);
                }}
              >
                {(input) => (
                  <Input
                    {...(input ?? {})}
                    borderRadius="full"
                    fontSize={['12px', 'md']}
                    onClick={(e) => input?.disc?.onOpen?.()}
                    onChange={(e) => input?.onChange(e.target.value)}
                    placeholder={t('createJob.enterEmail') || "Enter email"}
                    onKeyUp={(e) => {
                      input?.onKeyUp?.(e);
                      if (e.keyCode === 27) {
                        setEdit(false);
                      }
                    }}
                    autoFocus
                  />
                )}
              </EmailDropdown>
            )}
          </TagsInput>
        </FormControl>
      </Box>
    </VStack>
  );
};
